import { DateTime } from 'luxon';

export const reportsMorningMonitoring = {
    namespaced: true,

    state: {
        startDate: DateTime.now().toISO(),
        filter: {
            athletes: [],
            focuses: []
        }
    },

    getters: {
        startDate(state) {
            return state.startDate;
        },

        filter(state) {
            return state.filter;
        }
    },

    mutations: {
        setStartDate(state, date) {
            state.startDate = date;
        },

        setAthletes(state, payload) {
            state.filter.athletes = payload;
        }
    }
};

export default reportsMorningMonitoring;
